import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The language control moved into the appearance pane. This route stays as a
 * redirect so bookmarks, history entries and previously shared links to
 * `/app/settings/language` still land on the control rather than a 404.
 */
export const Route = createFileRoute(
  '/app/_authenticated/_dashboard/settings/language',
)({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings/appearance', replace: true });
  },
});
